<small [hidden]="valid" class="text-muted"></small>
<div *ngIf="valid" class="invalid-text-feedback">
  <span>{{msg}}</span>
</div>
